module.exports = __webpack_public_path__ + "static/neuron-78dc25120f535d84b5c1f5c4cec53220.png";